<template>
  <!-- //TODO: currency format -->
  <div class="row price-box-area">
    <div class="col-4 price-col">
      <div class="price-col__title">應收金額</div>
      <div class="price-col__box receivable">
        <p>$ {{ receivableAmount }}</p>
      </div>
    </div>
    <div class="col-4 price-col">
      <div class="price-col__title">實收金額</div>
      <div class="price-col__box actual-amount">
        <input
          type="number"
          placeholder="請輸入金額"
          :disabled="!enableInput"
          :class="{ disabled: !enableInput }"
          v-model.number="amt"
        />
      </div>
    </div>
    <div class="col-4 price-col">
      <div class="price-col__title">未收金額</div>
      <div class="price-col__box uncollect">
        <p>$ {{ unpaidAmount }}</p>
      </div>
    </div>

    <slot />
  </div>
</template>

<script>
export default {
  props: {
    enableInput: {
      required: false,
      type: Boolean,
      default() {
        return true;
      }
    },
    collectMoneyAgain: {
      required: false,
      type: Boolean,
      default() {
        return true;
      }
    },
    receivableAmount: {
      required: false,
      type: Number,
      default() {
        return 0;
      }
    },
    unpaidAmount: {
      required: false,
      type: Number
    },
    amount: {
      required: false,
      type: Number
    }
  },
  computed: {
    paidAmount() {
      return this.amount ? this.amount : 0;
    },
    amt: {
      get() {
        return this.amount;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>
